// src/services/userService.js
// ユーザー関連のFirestore操作

import { doc, setDoc, getDoc, updateDoc, collection, query, orderBy, limit, onSnapshot, serverTimestamp, getDocs, startAfter } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../config/firebase';

// ── ユーザー作成（オンボーディング完了時） ──
export async function createUser(uid, data) {
  const userRef = doc(db, 'users', uid);
  await setDoc(userRef, {
    uid,
    name: data.name,
    nickname: data.nickname || '',
    ageRange: data.age,
    phone: data.phone || '',
    lineId: data.line || '',
    contactMethod: data.method || 'LINE',
    experience: '',
    area: '',
    salary: '',
    schedule: '',
    priority: '',
    height: '',
    weight: '',
    photoUrls: [],
    status: '新規登録',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp() });
}

// ── チャット条件をユーザーに保存（ドキュメントがなければ新規作成） ──
export async function saveUserConditions(uid, conditions) {
  const userRef = doc(db, 'users', uid);
  await setDoc(userRef, {
    uid,
    experience: conditions.experience || '',
    area: conditions.area || conditions.area_other || '',
    salary: conditions.salary_beginner || conditions.salary_exp || '',
    schedule: conditions.schedule || '',
    priority: conditions.priority || '',
    ageRange: conditions.bodyinfo?.split('/')[0]?.trim() || '',
    height: conditions.bodyinfo?.split('/')[1]?.trim() || '',
    weight: conditions.bodyinfo?.split('/')[2]?.trim() || '',
    name: conditions.user_name || '',
    createdAt: serverTimestamp(), status: '求人紹介待ち',
    updatedAt: serverTimestamp() }, { merge: true });
}

// ── ユーザー写真アップロード ──
export async function uploadUserPhotos(uid, files) {
  const urls = [];
  for (let i = 0; i < files.length; i++) {
    const storageRef = ref(storage, `users/${uid}/photo_${i + 1}_${Date.now()}`);
    const snapshot = await uploadBytes(storageRef, files[i]);
    const url = await getDownloadURL(snapshot.ref);
    urls.push(url);
  }
  const userRef = doc(db, 'users', uid);
  await setDoc(userRef, {
    photoUrls: urls,
    updatedAt: serverTimestamp() }, { merge: true });
  return urls;
}

// ── ユーザー取得 ──
export async function getUser(uid) {
  const snap = await getDoc(doc(db, 'users', uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

// ── ユーザー一覧（管理画面用・リアルタイム） ──
export function subscribeUsers(callback) {
  const q = query(
    collection(db, 'users'),
    orderBy('createdAt', 'desc'),
    limit(200)
  );
  return onSnapshot(q, (snapshot) => {
    const users = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    callback(users);
  });
}

// ── ステータス更新 ──
export async function updateUserStatus(uid, status) {
  await updateDoc(doc(db, 'users', uid), {
    status,
    updatedAt: serverTimestamp() });
}


// ==============================
// Paging helpers for Admin lists
// 最新N件だけリアルタイム購読 + もっと見るで過去分を取得
// ==============================

export function subscribeLatestUsers(callback, pageSize = 50) {
  const q = query(
    collection(db, 'users'),
    orderBy('createdAt', 'desc'),
    limit(pageSize)
  );

  return onSnapshot(q, (snapshot) => {
    const items = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    const lastDoc = snapshot.docs[snapshot.docs.length - 1] || null;
    callback({ items, lastDoc });
  });
}

export async function fetchMoreUsers(lastDoc, pageSize = 50) {
  if (!lastDoc) return { items: [], lastDoc: null };

  const q = query(
    collection(db, 'users'),
    orderBy('createdAt', 'desc'),
    startAfter(lastDoc),
    limit(pageSize)
  );

  const snapshot = await getDocs(q);
  const items = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  const nextLastDoc = snapshot.docs[snapshot.docs.length - 1] || null;
  return { items, lastDoc: nextLastDoc };
}
